// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotek"];
export const count_PEOPLE_THINK_IT_IS_USEFUL = ["%(count)s \u010dlov\u011bk pova\u017euje za u\u017eite\u010dn\u00e9", "%(count)s lid\u00e9 pova\u017euj\u00ed za u\u017eite\u010dn\u00e9", "%(count)s lid\u00ed pova\u017euje za u\u017eite\u010dn\u00e9"];
export const REVIEW_OF_ALIKE_MODEL_stroller = "Recenze souvisej\u00edc\u00edho modelu %(stroller)s";
export const REVIEW_VERIFIED = "Ov\u011b\u0159en\u00e1 recenze";
export const STROLLER_REVIEW_RELATED_PRODUCT_IN_BAZAAR = "Prod\u00e1va te\u010f v bazaru:";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenze";
export const STROLLERS_NOT_APPROVED = "\u010dek\u00e1 na kontrolu";
export const USEFUL = "U\u017eite\u010dn\u00e9";
